import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";

const useCompanyData = (orgNr) => {
  return useQuery({
    queryKey: ["synaCompanyData", orgNr],
    enabled: !!orgNr,
    queryFn: async () => {
      const response = await apiClient.get(
        `/syna-integration/companies/${orgNr}`,
      );

      return response.data;
    },
  });
};

export { useCompanyData };
